import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import { useDispatch } from 'react-redux';

import { Card, CardSection } from 'components/Card';
import Message from 'components/Message';
import { closeModal } from 'components/Modal';
import Button from 'components/Button';

import { bem } from 'helpers/class-name';

import { ICONS } from 'constants/icons';
import { intlMessageShape } from 'constants/propTypes';

import './ConfirmationModal.scss';

const { block, element } = bem('confirmation-modal');

const ConfirmationModal = ({ title, message, confirmButtonText, confirmButtonStyle = 'primary', onConfirm }) => {
  const dispatch = useDispatch();

  return (
    <Card className={block()}>
      <CardSection flush className={element('header')}>
        <Message as="h1" message={title} />
        <div className={element('close-button')}>
          <button
            type="button"
            onClick={() => dispatch(closeModal())}
            name="close-button"
            aria-label="Close MFA Setup Modal"
            className={element('close-icon')}>
            <Isvg src={ICONS.cross} />
          </button>
        </div>
      </CardSection>

      <Message message={message} />

      <Button styled={confirmButtonStyle} type="button" onClick={onConfirm}>
        <Message message={confirmButtonText} />
      </Button>
    </Card>
  );
};

ConfirmationModal.propTypes = {
  title: PropTypes.shape(intlMessageShape),
  message: PropTypes.shape(intlMessageShape),
  confirmButtonText: PropTypes.shape(intlMessageShape),
  confirmButtonStyle: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
};

export default ConfirmationModal;
